import { apiRequest } from '../../../api/client';
import type { DismissResponse, ProcrastinationSuggestion } from '../../../api/types';

export async function suggestProcrastinationTask(
  energy: number,
  excludeTaskId?: number,
): Promise<ProcrastinationSuggestion> {
  const params = new URLSearchParams({ energy: String(energy) });
  if (excludeTaskId !== undefined) {
    params.set('exclude_task_id', String(excludeTaskId));
  }
  return apiRequest<ProcrastinationSuggestion>(
    `/tasks/procrastination-suggestion?${params.toString()}`,
  );
}

export async function dismissProcrastinationSuggestion(
  sessionId: number,
): Promise<DismissResponse> {
  return apiRequest<DismissResponse>('/tasks/procrastination-suggestion/dismiss', {
    method: 'POST',
    body: { session_id: sessionId },
  });
}
